module.exports = __webpack_public_path__ + "img/icon18.8a70eaab.png";